import { type ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Popover, type PopoverOrigin } from '@material-ui/core';

const DEFAULT_ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};
const DEFAULT_TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

interface FilterEditorPopoverProps {
  anchorEl: Element | null;
  onClose: () => void;
  transformOrigin?: PopoverOrigin;
  children: ReactNode;
}

export const FilterEditorPopover = ({
  anchorEl,
  onClose,
  transformOrigin = DEFAULT_TRANSFORM_ORIGIN,
  children,
}: FilterEditorPopoverProps) => (
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={DEFAULT_ANCHOR_ORIGIN}
    transformOrigin={transformOrigin}
    PaperProps={{ elevation: 1 }}
  >
    {children}
  </Popover>
);
